module.exports = __webpack_public_path__ + "img/EC.d4dcf221.svg";